export const RECORDING_STATUSES = [
  "not_expected",
  "capturing",
  "awaiting_provider",
  "archiving",
  "composing",
  "ready",
  "partial",
  "missing",
  "failed",
] as const;

export type RecordingStatus = (typeof RECORDING_STATUSES)[number];

export const RECORDING_SEGMENT_KINDS = [
  "conversation",
  "transfer",
  "queue_hold",
  "ivr",
  "voicemail",
  "final",
] as const;

export type RecordingSegmentKind = (typeof RECORDING_SEGMENT_KINDS)[number];

export const RECORDING_STORAGE_STATUSES = [
  "provider",
  "downloading",
  "archived",
  "verified",
  "source_unavailable",
  "failed",
] as const;

export type RecordingStorageStatus = (typeof RECORDING_STORAGE_STATUSES)[number];

export type RecordingJobType = "reconcile" | "archive" | "compose" | "notify";

export const LONG_RECORDING_IMPORT_THRESHOLD_SECONDS = 60 * 60;
export const RECORDING_WAIT_TIMEOUT_MS = 24 * 60 * 60 * 1000;

export type RecordingCaptureHandle = {
  kind: "call" | "conference";
  id: string;
};

export type RecordingPolicySnapshot = {
  enabled: boolean;
  source: "tenant_feature" | "tenant_default" | "missing_tenant" | "policy_error";
  capturedAt: string;
};

export type RecordingPauseInterval = {
  startedAt: string;
  endedAt: string | null;
  actorUserId: string;
};

export type RecordingSummary = {
  status: RecordingStatus;
  expected: boolean;
  paused: boolean;
  finalAvailable: boolean;
  rawSegmentCount: number;
  failureCode: string | null;
  canReconcile: boolean;
  canRetry: boolean;
  updatedAt: string | null;
  version: number;
  processingActive?: boolean;
};

export type RecordingSegmentMetadata = {
  id: number;
  provider: string;
  providerRecordingId: string | null;
  providerCallUuid: string | null;
  kind: RecordingSegmentKind;
  startedAt: string | null;
  endedAt: string | null;
  durationSeconds: number | null;
  storageStatus: RecordingStorageStatus;
  byteSize: number | null;
  sha256: string | null;
  mimeType: string | null;
  verifiedAt: string | null;
  final: boolean;
  compositionGeneration: number;
};

export type RecordingDetailResponse = {
  recording: RecordingSummary;
  segments: RecordingSegmentMetadata[];
};

export type RecordingStatusChangedPayload = {
  callLogId: string;
  tenantId: string;
  recording: RecordingSummary;
};
